<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner4.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="article_view">
                    <div class="sub_nav"><a @click="goTo('/')">首页</a>|<a @click="goTo(page_url)">{{ page_title }}</a></div>
                    <h2>{{ article.title }}</h2>
                    <!-- <div class="datetime">{{ article.datetime }}</div> -->
                    <div class="main_content" v-html="article.content"></div>
                </div>
                <div class="s_page"><a href="javascript:void(0);">上一篇</a><a href="javascript:void(0);">下一篇</a></div>
            </div>
        </div>


    </div>
</template>

<script>
import { ArticleView } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '公司简介',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            id: this.$route.query.id, //传入的id
            webType : this.$route.query.webType, //传入的webType
            page_url: this.$route.query.url, //传入的url
            page_title: this.$route.query.title, //传入的url

            article: {
                title:'',
                datetime:'',
                content:''
            },
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.ArticleView_data();
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        ArticleView_data(){ //文章分类显示
            ArticleView({
                webType : this.webType,
                id: this.id,
            }).then((res) => {
                console.log( res );
                this.article.title = res.rows[0].webTitle;
                this.article.datetime = res.rows[0].createTime;
                this.article.content = res.rows[0].webDescription;
            });
        },
    },
};
</script>
<style lang="less" scoped>
.s_page{
    display: none;
    user-select: none;
    height:40px;
    line-height: 40px;
    text-align: center;
    a{
        display: inline-block;
        padding:0px 15px;
        margin:0px 5px;
        font-size:12px;
        color:#666;
        text-decoration: none;
        height:30px;
        line-height: 30px;
        border:1px solid #ccc;
        border-radius: 100px;
    }
    a:hover{
        color:#d6000f;
        background-color: rgba(214, 0, 15, 0.1);
        border:1px solid #d6000f;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/ArticleView.vue